import React, { Fragment, memo, useState } from 'react'
import PropTypes from 'prop-types'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import { areaToUrl } from 'Utils/areaUtils'
import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'
import { listedDaysFormatter, unixTimeStampToDate, toMetric } from 'Utils/listingUtils'
import { PropertyDKS } from './dataSet'
// import css from './styles.js'
import {
  _FeaturesBlock, _Title, _ListingDetailKeyContainer,
  _TitleValueBlock, _TitleValueBlockHidden, _ShowButton,
} from './styles'

const onAreaClickFunc = (googleAnalyticsEvent) => {
  googleAnalyticsEvent({
    category: 'listing',
    action: '[Detail Area Click]',
  })
}

const renderFeatures = (props, mainKeysObject, additionalKeyObject, isMobileApp) => {
  const {
    listing, isLocked, unitSystemIsImperial,
    isCondo, sizeMin, sizeMax, sizeLabel,
    googleAnalyticsEvent, actualSize,
  } = props
  const { entry_date_unix: entryDateUnix, entry_date: entryDate } = listing
  const onAreaClick = () => onAreaClickFunc(googleAnalyticsEvent)
  return (
    <Fragment>
      {
        isCondo && listing.lowest_area ?
          <_TitleValueBlock
            title="Neighbourhood:"
            value={listing.lowest_area && listing.lowest_area.display_name}
            url={areaToUrl(listing.lowest_area)}
            key={listing.lowest_area.id}
            flexContainer
            valueIsLocked={isLocked}
            onValueClick={!isMobileApp && onAreaClick}
            isMobileApp={isMobileApp}
          />
          : null
      }
      {
        Object.keys(mainKeysObject).map(key => (
          <_TitleValueBlock
            title={mainKeysObject[key] + ':'}
            value={
              !listing[key] && listing[key] !== 0 ? '-' :
                listing[key].toString() === '0' ? 'No' :
                  listing[key].toString() === '1' ? 'Yes' : listing[key].toString()
            }
            key={key}
            flexContainer
            valueIsLocked={isLocked}
          />
        ))
      }
      {
        Object.keys(additionalKeyObject).map(key => (
          <_TitleValueBlockHidden
            title={additionalKeyObject[key] + ':'}
            value={
              !listing[key] && listing[key] !== 0 ? '-' :
                listing[key].toString() === '0' ? 'No' :
                  listing[key].toString() === '1' ? 'Yes' : listing[key].toString()
            }
            key={key}
            flexContainer
            valueIsLocked={isLocked}
          />
        ))
      }
      {
        isCondo && listing.corporation_jurisdiction ?
          <_TitleValueBlockHidden
            title="Corp #:"
            value={
              `${listing.corporation_jurisdiction}${listing.corporation_number ? `-${listing.corporation_number}` : ''}`
            }
            flexContainer
            valueIsLocked={isLocked}
          />
          : null
      }
      <_TitleValueBlockHidden
        title="MLS Size:"
        value={
          sizeMin === sizeMax && sizeMin ? `${sizeMin} ${sizeLabel}`
            :
            sizeMax ? `${sizeMin || 0}-${sizeMax} ${sizeLabel}` :
              sizeMin ? `+${sizeMin} ${sizeLabel}` : actualSize ? `${actualSize} ${sizeLabel}` : '-'
        }
        flexContainer
        valueIsLocked={isLocked}
      />
      {
        ['front', 'depth'].filter(key => Boolean(listing[`lot_${key}`])).map(key => (
          <_TitleValueBlockHidden
            title={`Lot ${key}:`}
            value={
              unitSystemIsImperial ? `${listing[`lot_${key}`]} Ft` :
                `${toMetric(listing[`lot_${key}`])} M`
            }
            key={key}
            flexContainer
            valueIsLocked={isLocked}
          />
        ))
      }
      {
        <_TitleValueBlock
          title={'Listed on:'}
          value={entryDate ? `${format(parseISO(entryDate), 'MMM d, y')}`
            : entryDateUnix
              ? `${listedDaysFormatter(unixTimeStampToDate(entryDateUnix))} ago`
              : '-'}
          key={'listed on'}
          flexContainer
          valueIsLocked={isLocked}
        />
      }
    </Fragment>
  )
}

export const ListingFeatures = (props) => {
  const [allShown, toggleFeatures] = useState(false)

  const { listing, isMobileApp } = props
  if(listing) {
    const propertyClass = listing.property_class === 'Condo' ? 'condo' : 'freehold'
    const offer = listing.offer === 'Rent' ? 'rent' : 'sale'
    const propertyMainKeys = PropertyDKS.main
    const propertyAdditionalKeys = PropertyDKS[offer][propertyClass]
    return (
      <_FeaturesBlock>
        <_Title>Property details</_Title>
        <_ListingDetailKeyContainer allShown={allShown}>
          <NoMarginRow>
            {renderFeatures(props, propertyMainKeys, propertyAdditionalKeys, isMobileApp)}
          </NoMarginRow>
          <_ShowButton
            onClick={() => toggleFeatures(value => !value)}
          >
            {allShown ? 'Hide' : 'Show all'} details
          </_ShowButton>
        </_ListingDetailKeyContainer>
      </_FeaturesBlock>
    )
  }
  return null
}

renderFeatures.propTypes = {
  isLocked: PropTypes.bool,
  unitSystemIsImperial: PropTypes.bool,
  listing: PropTypes.shape({
    corporation_jurisdiction: PropTypes.string,
    corporation_number: PropTypes.string,
    lowest_area: PropTypes.shape({
      display_name: PropTypes.string,
      id: PropTypes.number,
    }),
    tour_url: PropTypes.string,
    property_class: PropTypes.string,
    offer: PropTypes.string,
    end_date: PropTypes.string,
    entry_date: PropTypes.string,
    entry_date_unix: PropTypes.number,
  }),
  isCondo: PropTypes.bool,
  sizeMin: PropTypes.number,
  sizeMax: PropTypes.number,
  sizeLabel: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
}

ListingFeatures.propTypes = {
  listing: PropTypes.shape({
    corporation_jurisdiction: PropTypes.string,
    corporation_number: PropTypes.number,
    lowest_area: PropTypes.shape({
      display_name: PropTypes.string,
      id: PropTypes.number,
    }),
    tour_url: PropTypes.string,
    property_class: PropTypes.string,
    offer: PropTypes.string,
  }),
  isMobileApp: PropTypes.bool,
}

export default memo(ListingFeatures)
